import MainNotification from "../components/notification/main-notification";

function Notification() {
  return (
    <div className="w-[90%] lg:w-[95%] mx-auto mt-8">
        <MainNotification/>
    </div>
  );
}

export default Notification;


